import React from 'react'

const CircleClose = props => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' {...props}>
    <path d='M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.597 17.954l-4.591-4.55L7.451 18l-1.405-1.405 4.547-4.592L6 7.451l1.405-1.405 4.588 4.543L16.538 6l1.416 1.403-4.546 4.587L18 16.538l-1.403 1.416z' />
  </svg>
)

export default CircleClose
